module.exports = __webpack_public_path__ + "img/logo.e8aba437.png";